<template>
	<div class="barRoot">
		<div class="barContainer">
			<img class="logoImg" src="../assets/logo.png" />
			<div class="navs">
				<div class="nav navSelected"  >
					<router-link to="/main" ><span @click='clickPage(0)'>首页</span></router-link>
					<div class="navLine" v-show='currentIndex == 0'></div>
				</div>
				<div class="nav" >
					<router-link to="/product" ><span @click='clickPage(1)'>行业产品</span></router-link>
					<div class="navLine" v-show='currentIndex == 1'></div>
				</div>
				<div class="nav" >
					<router-link to="/samples" ><span @click='clickPage(2)'>案例</span></router-link>
					<div class="navLine" v-show='currentIndex == 2'></div>
				</div>
				<div class="nav" >
					<router-link to="/aboutUs" ><span @click='clickPage(3)'>关于我们</span></router-link>
					<div class="navLine" v-show='currentIndex == 3'></div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import VueEvent from '@/bus/event.js'
export default{
	name:'Bar',
	mounted() {
		var path = this.$route.path
		if(path == '/main'){
			this.currentIndex = 0;
		}else if(path == '/product'){
			this.currentIndex = 1;
		}else if(path == '/samples'){
			this.currentIndex = 2;
		}else if(path == '/aboutUs'){
			this.currentIndex = 3;
		}
		this.clickPage(this.currentIndex)
		var _this = this
		window.updateNavCallBack = function(pgNum){
			_this.clickPage(pgNum)
		}
	},
	methods:{
		clickPage(index){
			var elements = document.getElementsByClassName('nav')
			for (var i = 0; i < elements.length; i++) {
				elements[i].className = 'nav'
			}
			var elm = document.getElementsByClassName('nav')[index]
			this.currentIndex = index
			elm.className = 'nav navSelected'
		}
	},
	data(){
		return{
			currentIndex:0
		}
	}
}
</script>

<style scoped="scoped">
	.navLine{
		width: 100%;
		height: 3px;
		background: #0080F6;
		border-radius: 2px;
		margin-top: -3px;
	}
	.nav:nth-child(2){
		margin-left: 116px;
	}
	.nav:nth-child(3){
		margin-left: 268px;
	}
	.nav:nth-child(4){
		margin-left: 384px;
	}
	.nav{
		/* font-family: SourceHanSansK-Normal; */
		font-size: 18px;
		color: #FFFFFF;
		line-height: 92px;
		position: absolute;
		font-weight: 400;
		white-space: nowrap;
	}
	
	a{
		text-decoration:none;
		color: #ffffff;
		line-height: 92px;
	}
	.aSelected{
		color: #0080F6;
	}
	.navSelected{
		/* font-family: SourceHanSansK-Medium; */
		font-size: 18px;
		font-weight: 500;
		line-height: 92px;
		position: absolute;
		white-space: nowrap;
	}
	.navSelected a{
		color: #0080F6;
	}
	.navs{
		height: 92px;
		margin-left: 275px;
		float: left;
	}
	.logoImg{
		width: 142.26px;
		height:50px;
		margin-top: 21px;
		margin-left: 300px;
		float: left;
	}
	
	.barContainer{
		/* width: 1200px; */
		/* margin: 0 auto; */
	}
	.barRoot{
		background-color: #111111;
		/* min-width: 1300px; */
		width: 1920px;
		height: 92px;
	}
</style>
